import {IndustryClassList} from "./IndustryClassList";
import {IndustryClassEdit} from "./IndustryClassEdit";
import {IndustryClassCreate} from "./IndustryClassCreate";

export default {
    list: IndustryClassList,
    create: IndustryClassCreate,
    edit: IndustryClassEdit
};
